/**
 *
 * @author: Matthew Rawson @ 09/08/2018 16:43
 * @description:
 * @notes:
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import {Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts"

import {round} from "lodash"
import styled from "styled-components"

import {injectIntl} from "@irati/utils/lang"
import {Hr} from "@irati/ui/src/Layout"
import getId from "@irati/utils/id"
import {greys, perkbox} from "@irati/ui/src/global/colors"
import Expand from "@irati/ui/src/Expander"
import padding from "@irati/ui/src/global/padding"
import Loading from "@irati/ui/src/Loading"
import {AnalysisContext} from "@irati/insights/context"
import {overrideAuth} from "@irati/insights/utils/apollo"

import {getSurveys} from "../../graph/surveys"

const GraphContainer = styled.div`
  padding-top: ${padding.base};
`

const ChartWrapper = styled.div`
  padding: 0 ${padding.small} ${padding.small};
`

/**
 * Takes a date string and formats it to a human readable string
 * @param item
 * @returns {string}
 * @private
 */
const _formatDateAxisItem = (intl, item) => {
  return intl.formatDate(item, {
    year: "2-digit",
    month: "numeric"
  })
}


/**
 *
 * Display the rechart graph, with proptype expected data structure.
 *
 * @param data
 * @param props
 * @returns {*}
 * @constructor
 */
class SurveysAverageScore extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    schedule: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {data: null, submit: null}
  }

  handleChange = (isExpanded, analysisContext) => {
    if (isExpanded) this.init(analysisContext)
  }

  init = ({isDemo, demoTenantAccessToken}) => {
    const {schedule, filters} = this.props
    const {tenant, id, test} = schedule
    const {teamId, driverId, time} = filters

    const params = {
      tenant,
      scheduleId: id,
      minOpenedAt: time,
      orderBy: "createdAt",
      orderDirection: "asc",
      team: teamId,
      driverId,
      withQuestionStats: true,
      withResponseCount: true,
      test
    }
    const submit = getSurveys(params, overrideAuth(demoTenantAccessToken, isDemo).context)
      .then(({results}) => this.setState({data: results}))
    this.setState({submit})
  }

  render() {
    return (
      <AnalysisContext.Consumer>
        {(analysisContext) => {
          const {formatMessage, intl} = this.props
          const idNamespace = getId("SurveysAverageScore", this.props)
          const idPbGrad = getId("gradPB", idNamespace)
          const YAxisScale = [1, 5]
          const TickScale = [1, 2, 3, 4, 5]
          return (
            <div>
              <Hr />
              <ChartWrapper>
                <Expand
                  onChange={(isExpanded) => this.handleChange(isExpanded, analysisContext)}
                  fullWidth
                  showText={formatMessage({id: "insights.analysis.charts.expander.label"})}>
                  <Loading load={this.state.submit}>
                    <GraphContainer>
                      <ResponsiveContainer width="100%" height={300}>
                        <AreaChart id={idNamespace} data={this.state.data} margin={{left: -35, right: 10}}>
                          <defs>
                            <linearGradient id={idPbGrad} x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor={perkbox.blue} stopOpacity={0.4} />
                              <stop offset="75%" stopColor={perkbox.blue} stopOpacity={0} />
                            </linearGradient>
                          </defs>
                          <XAxis
                            dataKey="createdAt"
                            tickFormatter={(item) => _formatDateAxisItem(intl, item)}
                            tickLine={false}
                            fontFamily="Lato, sans-serif"
                            fontSize="12px"
                            stroke={greys.mediumLight}
                            dy={10} />
                          <YAxis
                            domain={YAxisScale}
                            tickLine={false}
                            fontFamily="Lato, sans-serif"
                            fontSize="12px"
                            stroke={perkbox.blue}
                            ticks={TickScale}
                            tick={{fill: greys.mediumLight}}
                            dx={-5} />
                          <Tooltip
                            isAnimationActive={false}
                            formatter={(value) => {
                              return round(value, 1)
                            }}
                            labelFormatter={() => ""}
                            cursor={false} />
                          <Area
                            type="monotone"
                            dot={{stroke: perkbox.blue, strokeWidth: 5, fill: "white", r: 6}}
                            activeDot={{stroke: "white"}}
                            dataKey="questionStats.answersAverage"
                            stroke={perkbox.blue}
                            strokeWidth={5}
                            fillOpacity={1}
                            fill={`url(#${idPbGrad})`}
                            name="Score" />
                        </AreaChart>
                      </ResponsiveContainer>
                    </GraphContainer>
                  </Loading>
                </Expand>
              </ChartWrapper>
            </div>
          )
        }}
      </AnalysisContext.Consumer>
    )
  }
}

export default injectIntl(SurveysAverageScore)
